import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useArchiveDiscount(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const archiveDiscount = (discountId: string): Promise<AxiosResponse<null>> => {
    return client.put(`discounts/${discountId}/archive/`);
  };

  return useMutation(archiveDiscount, {
    onSuccess: () => {
      queryClient.invalidateQueries('discounts');
    },
  });
}
